import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      position: 'relative',
      maxWidth: '398px',
    },
    fileIcon: {
      width: '100%',
      maxWidth: '398px',
      maxHeight: '100%',
    },
    progressIconContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    progressIcon: {},
  },
  { name: 'file-loader' },
);

export default useStyles;
